import Editorial from './Editorial';
export default Editorial;
